import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import { Container, Row, Col, Button } from "react-bootstrap";
import logo from "../assets/images/logo.webp";
import Menu from "../assets/images/icons/toggle-icon.png";
import GamesSearchModal from "../views/components/GamesSearchModal";
import { getNotifications } from "../redux/app/actions";
import { AiOutlineClose } from "react-icons/ai";
const Header = () => {
  const navigate = useNavigate();
  const { appDetails } = useSelector((state) => state.app);
  const [showLeftbarToggle, setShowLeftbarToggle] = useState(false);
  const htmlElement = document.documentElement;
  const [websiteNotifications, setWebsiteNotifications] = useState([]);
  const [showNotifications, setShowNotifications] = useState(true);
  const handleToggleClick = () => {
    const realTimeValue = !showLeftbarToggle;
    if (realTimeValue) {
      htmlElement.style.overflow = "hidden";
      document.body.classList.add("leftbat-opened");
    } else {
      htmlElement.style.overflow = "auto";
      document.body.classList.remove("leftbat-opened");
    }
    setShowLeftbarToggle(realTimeValue);
  };

  const navigationLinks = [
    { name: "Home", path: "/" },
    { name: "Cricket", path: "/Exchange/Cricket" },
    { name: "Casino", path: "/casino" },
    { name: "Evolution", path: "/casino/evolution" },
    { name: "Ezugi", path: "/casino/ezugi" },
    { name: "Int Casino", path: "/int-casino" },
    { name: "Exchange", path: "/Exchange/Inplay" },
    { name: "Tennis", path: "/Exchange/Tennis" },
    { name: "Football", path: "/Exchange/Soccer" },
    { name: "Horse Racing", path: "/Exchange/Horse Racing" },
    { name: "Politics", path: "/Exchange/Politics" },
    { name: "Greyhound Racing", path: "/Exchange/Greyhound Racing" },
    { name: "Kabaddi", path: "/Exchange/Kabaddi" },
    { name: "Sports Book", path: "/betby" },
    { name: "Sports Book 2", path: "/sportsbook2" },
    { name: "Slots", path: "/slots" },
    { name: "Kingmaker", path: "/kingmaker" },
    { name: "Aura", path: "/aura-games" },
    { name: "Aviator", path: "/casino/spribe/aviator" },
    { name: "Ice Hockey", path: "/Exchange/Ice Hockey" },
    { name: "Basketball", path: "/Exchange/Basketball" },
    { name: "Archery", path: "/Exchange/Archery" },
    { name: "Table Tennis", path: "/Exchange/Table Tennis" },
    { name: "Badminton", path: "/Exchange/Badminton" },
    { name: "Motor Sport", path: "/Exchange/Motor Sport" },
  ];
  useEffect(() => {
    loadNotifications();
    return () => {};
  }, []);
  const loadNotifications = async () => {
    // get notifications
    const notifications = await getNotifications();
    if (notifications && notifications?.data?.data) {
      setShowNotifications(true);
      setWebsiteNotifications(notifications?.data?.data);
    }
  };

  return (
    <>
      {(websiteNotifications.length && showNotifications && (
        <div className="marqu">
          <marquee>
            {websiteNotifications.map((notf, idx) => (
              <label style={{ marginRight: "30px" }} key={idx}>
                {notf?.content}
              </label>
            ))}
          </marquee>
          <span onClick={() => setShowNotifications(false)}>
            <AiOutlineClose />
          </span>
        </div>
      )) ||
        null}
      <header className="header beforeheader">
        <Container fluid>
          <Row>
            <Col xs={12}>
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                  <div className="logo">
                    <a href="/">
                      <img src={appDetails?.LOGO_URL} alt="Logo" />
                      {/* <img src={logo} alt="Logo" /> */}
                    </a>
                  </div>
                </div>

                <div className="headerRight">
                  <GamesSearchModal />

                  <Button
                    variant="primary"
                    onClick={() => {
                      navigate("/sign-in");
                    }}
                    className="button-primary btn_signin"
                  >
                    SIGN IN
                  </Button>
                  <Button
                    variant="primary"
                    onClick={() => {
                      navigate("/mobile-number");
                    }}
                    className="button-primary btn_signup btn-secondary ms-2"
                  >
                    SIGN UP
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </Container>

        <div className="bottom_head">
          <ul>
            {navigationLinks.map((link, index) => (
              <li key={index}>
                <NavLink
                  to={link.path}
                  className={({ isActive }) =>
                    `nav-link ${isActive ? "active" : ""} ${
                      link.name === "Sports Book 2" ? "new-badge" : ""
                    }`
                  }
                >
                  {link.name === "Sports Book 2" && (
                    <div className="new">New</div>
                  )}
                  {link.name}
                </NavLink>
              </li>
            ))}
          </ul>
        </div>
      </header>
    </>
  );
};

export default Header;
